'use client'

import { defaultOptions, generateImageUrl } from '@/lib/generate-image-url'

export default function contentfulImageLoader({
  src,
  width,
  quality,
}: {
  src: string
  width: number
  quality?: number
}) {
  if (src.includes('ctfassets.net')) {
    return generateImageUrl(src, { ...defaultOptions, width, quality })
  }
  const sep = src.includes('?') ? '&' : '?'
  return `${src}${sep}w=${width}${quality ? `&q=${quality}` : ''}`
}
